import { createAsyncThunk } from '@reduxjs/toolkit'

export const getLiveTransactions = createAsyncThunk(
  'casino/live-transactions',
  async () => ({ rows: [], count: 0 })
)

export const getHighRollers = createAsyncThunk(
  'casino/high-rollers',
  async () => ({ rows: [], count: 0 })
)

export const getGames = createAsyncThunk(
  'casino/games',
  async () => ({ rows: [], count: 0 })
)
